import { BlockUnblockUser, List } from "../../services/user.services";
import { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { DatePicker } from "rsuite";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { handleServerValidations } from "../../../../utils/commonfunction";

const CalendarCaret = () => <i className="fi fi-rr-calendar calendar-icon-inside" />;

export default function Users() {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ name: null, date: null });
  const [openPopupIndex, setOpenPopupIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const popupRef = useRef(null);
  const navigate = useNavigate();
  const [statsupdate, setStatusUpdate] = useState("false");

  function useDebounce(value, delay = 500) {
    const [debouncedValue, setDebouncedValue] = useState(value);
   

    useEffect(() => {
      const timer = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(timer);
    }, [value, delay]);

    return debouncedValue;
  }

  const debouncedFilters = useDebounce(filters, 600);

  const fetchUsers = async (page = 1) => {
    try {
      setLoading(true);
      const response = await List({
        ...debouncedFilters,
        page,
        limit: 10,
      });

      setUsers(response.data?.list || []);
      setCurrentPage(response.data?.page || 1);
      setTotalPages(response.data?.total_records || 1);
    } catch (error) {
      console.error("Error fetching users", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setOpenPopupIndex(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setCurrentPage(1); // reset to first page when filters change
    fetchUsers(1);
  }, [statsupdate, debouncedFilters]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      fetchUsers(page);
    }
  };

  const resetFilter = (e) => {
    setFilters({ title: null, date: null });
  };

  const ChangeBlockStatus = (id) => {
      // const formData = new FormData();
      // formData.append("o_id", JSON.stringify(id));
      Swal.fire({
        customClass: "swal-wide",
        title: t("msg_are_you_sure"),
        text: t("Do you want to change the status?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#403fad",
        cancelButtonColor: "#f1388b",
        confirmButtonText: t("btn_yes"),
        cancelButtonText: t("btn_cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          BlockUnblockUser({o_id: id})
            .then((response) => {
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
                setStatusUpdate((prev) => !prev);
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
            })
            .catch((error) => {
              console.log("error===>");
            });
        }
      });
    };

  return (
    <>
      <div className="main-content">
        <div className="customer-part">
          <div className="card-box">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 w-100 mb-4">
              <div className="search-bar d-flex flex-wrap align-items-center gap-2">
                <div className="search-input">
                <input type="text" className="form-control" placeholder="Search by name" value={filters?.name||""} onChange={(e) => setFilters({ ...filters, name: e.target.value })} />
              <i className="fi fi-rs-search" />
                </div>
                <div className="date-input">
                  <DatePicker
                    value={filters.date ? new Date(filters.date) : null}
                    onChange={(date) => {
                      setFilters({ ...filters, date: date });
                    }}
                    format="yyyy-MM-dd"
                    placeholder="Select date"
                    cleanable={true}
                    oneTap={true}
                    caretAs={CalendarCaret}
                    className="custom-date-picker"
                  />
                </div>

                <button type="reset" value="Reset" onClick={resetFilter} className="btn btn-oring ripple">
                  {t("btn_reset_filter")}
                </button>
              </div>
              <button className="btn btn-oring text-nowrap" onClick={()=>{navigate('/business/users/create-payment')}}>Create Offline Payment</button>
            </div>

            {/* Transactions Table */}
            <div className="table-box table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    {/* <th>Customer Id</th> */}
                    <th>Customer Name</th>
                    <th>Phone</th>
                    <th>Total Transactions</th>
                    <th>Created Date</th>
                    <th>Block/Unblock</th>
                
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8">Loading...</td>
                    </tr>
                  ) : users.length === 0 ? (
                    <tr className="text-center">
                      <td className="m-2" colSpan="8">
                        No Users found
                      </td>
                    </tr>
                  ) : (
                    users.map((txn, index) => (
                      <tr key={index}>
                        <td>{txn?.fullName || txn?.name || txn?.email || "N/A"}</td>
                        <td>{txn?.phone_number?.fullNumber || txn?.phone_number?.phone || "N/A"}</td>
                        <td>{txn?.total_transactions || "N/A"}</td>
                        <td>
                          {new Date(txn.createdAt).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                        </td>
                        <td>
                          <label className={"custom-switch cp" + (txn.isBlockedByBusiness !== true ? " e_none" : "")}>
                            <input className="custom-switch-input cp" type="checkbox" checked={txn?.isBlockedByBusiness === true} onChange={() => ChangeBlockStatus(txn?._id)} />
                            <span className="custom-switch-indicator cp"></span>
                          </label>
                        </td>
                        <td className="popup">
                          <button className="btn btn-sm mt-1" onClick={() => setOpenPopupIndex(index)}>
                          <Link to={`/business/users/view/${txn._id}`}> <i className="fi fi-rr-eye" /></Link>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="pagination d-flex justify-content-center mt-3">
              <button className="btn btn-light me-2" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}>
                Prev
              </button>
              <span className="align-self-center">
                Page {currentPage} of {totalPages}
              </span>
              <button className="btn btn-light ms-2" disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}>
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
